import React, { useState } from "react";
import { BrandMark } from "../ModuleIcon";

export const authCss = `
.auth-wrap{position:fixed;inset:0;z-index:9999;background:var(--bg);display:flex;align-items:center;justify-content:center;padding:16px;overflow-y:auto}
.auth-card{width:100%;max-width:380px;box-sizing:border-box;background:var(--card);border:1px solid var(--border);border-radius:10px;padding:28px 28px 24px;box-shadow:var(--shadow-md)}
.auth-in{width:100%;box-sizing:border-box;padding:9px 12px;border-radius:var(--radius-sm);border:1px solid var(--border-strong);background:var(--bg-input);color:var(--text);font-size:14px;font-family:inherit;transition:border-color .12s,box-shadow .12s}
.auth-in:focus{outline:none;border-color:var(--accent);box-shadow:var(--focus-ring)}
.auth-in:disabled{opacity:.7}
.auth-btn{width:100%;padding:10px 0;border-radius:var(--radius-sm);border:1px solid var(--accent);background:var(--accent);color:#fff;font-size:14px;font-weight:600;cursor:pointer;font-family:inherit;transition:background .12s,border-color .12s}
.auth-btn:hover:not(:disabled){background:var(--accent-hover);border-color:var(--accent-hover)}
.auth-btn:focus-visible,.auth-link:focus-visible,.auth-eye:focus-visible,.auth-ghost:focus-visible{outline:none;box-shadow:var(--focus-ring)}
.auth-btn:disabled{opacity:.6;cursor:not-allowed}
.auth-ghost{padding:9px 14px;border-radius:var(--radius-sm);border:1px solid var(--border-strong);background:var(--card);color:var(--text);font-size:13px;font-weight:600;cursor:pointer;font-family:inherit;transition:background .12s}
.auth-ghost:hover:not(:disabled){background:var(--bg-hover)}
.auth-link{background:none;border:none;padding:2px 0;color:var(--accent);font-size:13px;cursor:pointer;font-family:inherit}
.auth-link:hover{text-decoration:underline}
.auth-eye{position:absolute;right:4px;top:50%;transform:translateY(-50%);background:none;border:none;padding:5px 8px;color:var(--text-muted);font-size:12px;cursor:pointer;border-radius:4px;font-family:inherit;transition:color .12s}
.auth-eye:hover{color:var(--text)}
@media (max-width:640px){
 .auth-wrap{padding:0;align-items:flex-start;background:var(--card)}
 .auth-card{max-width:none;border:none;border-radius:0;box-shadow:none;padding:24px 16px}
 .auth-in{font-size:16px;padding:9px 10px}
}`;

export const S = {
  label: { display: "block", fontSize: 12, fontWeight: 600, color: "var(--text-muted)", marginBottom: 4 },
  field: { marginBottom: 12 },
  err: { color: "var(--danger)", fontSize: 12, marginBottom: 10, lineHeight: 1.4, overflowWrap: "anywhere" },
  ok: { color: "var(--success)", fontSize: 13, marginBottom: 10, lineHeight: 1.4 },
  check: { display: "flex", alignItems: "center", gap: 8, cursor: "pointer", userSelect: "none", fontSize: 13, color: "var(--text-muted)", margin: "4px 0 14px" },
  brand: { marginBottom: 22 },
  title: { fontSize: 17, fontWeight: 700, color: "var(--text)", lineHeight: 1.2, margin: 0 },
};

export const MIN_LEN = 10;

export function Brand({ heading, sub }) {
  return (
    <div style={S.brand}>
      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 18 }}>
        <BrandMark size={28} />
        <span style={{ fontSize: 15, fontWeight: 700, color: "var(--text)", letterSpacing: "-0.01em" }}>SochOne Tools</span>
      </div>
      <h1 style={S.title}>{heading}</h1>
      {sub && <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 4 }}>{sub}</div>}
    </div>
  );
}

export function PasswordField({ id, label, value, onChange, autoComplete, autoFocus, disabled }) {
  const [show, setShow] = useState(false);
  return (
    <div style={S.field}>
      <label htmlFor={id} style={S.label}>{label}</label>
      <div style={{ position: "relative" }}>
        <input
          id={id} className="auth-in" type={show ? "text" : "password"} value={value}
          onChange={(e) => onChange(e.target.value)} autoComplete={autoComplete}
          autoFocus={autoFocus} disabled={disabled}
          style={{ paddingRight: 56 }}
        />
        <button type="button" className="auth-eye" onClick={() => setShow((s) => !s)} aria-label={show ? "Hide password" : "Show password"}>
          {show ? "Hide" : "Show"}
        </button>
      </div>
    </div>
  );
}
